import type { Replacements, TranslationPluralKeyArg, Translations } from '../shared/types';
import type { UsedTranslationsTracker } from '../UsedTranslationsTracker';

import { getPluralKey } from './pluralKey';
import { translate } from './translate';

export function translatePlural(
	{
		locale,
		translations,
		tracker,
	}: {
		locale: string;
		translations: readonly Translations[];
		tracker?: UsedTranslationsTracker;
	},
	key: TranslationPluralKeyArg,
	count: number,
	replacements: Replacements | undefined,
): string {
	return translate({ translations, tracker }, getPluralKey(locale, key, count), replacements);
}
